import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, useSort, pick, useFacets } from '@nosto/preact'
import { useEffect, useState } from 'preact/hooks'
import Products from './Products'
import Toolbar from './Toolbar'
import BottomToolbar from './BottomToolbar'
import SelectedFilters from './SelectedFilters'
import { wrapContent } from './ContentWrapper'
import Loader from './elements/Loader'
import NoResults from './NoResults'
import Sidebar from './Sidebar'

export function CategoryBody({ loading, foundProducts }) {
    const { query, response, pageType } = useAppStateSelector((state) =>
        pick(state, 'loading', 'query', 'response', 'pageType')
    )
    const docCount = response.products?.total ?? 0
    const [bottomDescription, setBottomDescription] = useState(null)

    useEffect(() => {
        const bottomDescElement = document.getElementById('collection-description_bottom')
        if (bottomDescElement) {
            setBottomDescription(bottomDescElement.innerHTML)
        }
    }, [])

    if (loading) return <Loader />

    return foundProducts ? (
        <>
            <Sidebar />
            <div data-section-type="collection-template">
                <p class="medium-up--hide text-center" data-scroll-to="">
                    {docCount} tuotetta
                </p>
                <Products />
                <BottomToolbar />
            </div>
            {bottomDescription && <div dangerouslySetInnerHTML={{ __html: bottomDescription }}></div>}
        </>
    ) : (
        <NoResults />
    )
}

export default wrapContent('category', CategoryBody)
